<h4 class="category-subtitle">Vehicles:</h4>
@if (selectedVehicle && mobilityVehicles) {
  <div
    class="category-icons-container"
    >
    @for (vehicle of mobilityVehicles; track vehicle) {
      <div>
        <button
          class="category-select-btn"
          [class.answered]="hasEntries(vehicle)"
          [class.selected]="selectedVehicle.id === vehicle.id"
          (click)="selectVehicle(vehicle)"
          >
          <app-icon
            [name]="vehicle.icon || 'question_mark'"
            color="black"
          ></app-icon>
        </button>
      </div>
    }
  </div>
}

@if (selectedVehicle) {
  <div>
    <p class="category-title">
      How many kilometers did you travel by
      <b>{{ selectedVehicle.text.text_en || selectedVehicle.text.text_de }}</b>
      today?
    </p>
    <!-- Energy Source Menu (replaces popup) -->
    <mat-menu #energySourceMenu="matMenu">
      @for (energySource of selectedVehicle.energySources; track energySource) {
        <button
          mat-menu-item
          (click)="selectEnergySource(energySource)"
          >
          {{ energySource.text.text_en || energySource.text.text_de }}
        </button>
      }
    </mat-menu>
    <!-- Existing Entries List -->
    @if (getEntriesForVehicle(selectedVehicle).length > 0) {
      <div
        class="entries-list"
        >
        @for (entry of getEntriesForVehicle(selectedVehicle); track entry) {
          <div
            class="category-item"
            >
            <span class="category-item-name"
              ><b>{{ entry.distance }} km</b></span
              >
              <span class="category-item-description">{{
                getEnergySourceText(entry.mobilityEmissionId)
              }}</span>
              <button class="increment-decrement-button" (click)="removeEntry(entry)">
                <app-icon [name]="'trash'" color="black" [size]="'20px'"></app-icon>
              </button>
            </div>
          }
        </div>
      }
      <!-- Add New Entry Section -->
      <div class="add-section">
        <div class="energy-source-section">
          <p class="energy-source-title">
            Type of energy:
            <b>{{
              selectedEnergySource
              ? selectedEnergySource.text.text_en ||
              selectedEnergySource.text.text_de
              : "Select energy source"
            }}</b>
          </p>
          @if (hasMultipleEnergySources()) {
            <button
              class="icon-btn"
              [matMenuTriggerFor]="energySourceMenu"
              >
              <app-icon
                [name]="'edit_notes'"
                color="black"
                [size]="'20px'"
              ></app-icon>
            </button>
          }
        </div>
        <div class="input-container">
          <mat-form-field appearance="outline" class="distance-input">
            <mat-label>Distance</mat-label>
            <input
              matInput
              type="number"
              min="0"
              step="0.1"
              placeholder="0.00"
              #distanceInput
              [(ngModel)]="distanceValue"
              (keydown.enter)="addEntry(distanceInput.value)"
              />
            <span matTextSuffix> (km)</span>
          </mat-form-field>
          <button
            class="btn add-btn"
            (click)="addEntry(distanceInput.value)"
        [disabled]="
          !selectedEnergySource ||
          !distanceInput.value ||
          distanceInput.value === '0'
        "
            >
            <app-icon [name]="'plus'" color="white" [size]="'24px'"></app-icon>
          </button>
        </div>
      </div>
      <div class="continue-button-container">
        <button class="btn" (click)="onContinue()">
          Continue
          @if (selectedVehicle) {
            <app-icon
              [name]="getNextVehicleIcon(selectedVehicle)"
              size="24px"
              color="white"
            ></app-icon>
          }
        </button>
      </div>
    </div>
  }
